const onHideCallbacks = []

export default onHideCallbacks
